export const CARDS_BLOCK_b04 =   {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#F6F6F6",
    "padding": "120px 20px 120px 20px"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#333333",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 80px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 60px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 40px 0px"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746629894093,
      "elIndex": 0,
      "text": "[[id]]",
      "params": [
        {
          "value": "id",
          "label": "id"
        }
      ],
      "location": "A",
      "styleProps": {
        "color": "#116dff",
        "font-size": "4.5rem",
        "line-height": "1",
        "font-weight": "600",
        "margin": "0px 0px 10px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 1,
      "text": "[[name]]",
      "location": "A",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "font-weight": "600",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsTab": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746531362022,
      "elIndex": 2,
      "text": "[[role]]",
      "location": "A",
      "params": [
        {
          "value": "role",
          "label": "role"
        }
      ],
      "styleProps": {
        "margin": "10px 0px 0px 0px",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "color": "#ffffff",
        "font-weight": "400"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "0.875rem",
        "line-height": "1.25rem",
        "margin": "1px 0px 0px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746548627463,
      "elIndex": 3,
      "text": "[[description]]",
      "location": "B",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "styleProps": {
        "color": "#ffffff",
        "margin": "20px 0px 0px 0px",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "padding": "0px 0px 0px 50px",
        "border-width": "0px 0px  0px 2px"
      },
      "stylePropsTab": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "padding": "0px 0px 0px 40px"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "padding": "0px 0px 0px 40px"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 3
    },
    "layout": "l5",
    "cardstyleProps": {
      "padding": "10px 10px 10px 10px"
    },
    "cardstylePropsMob": {
      "padding": "40px 0px 10px 0px"
    },
    "cardstylePropsTab": {
      "padding": "60px 10px 10px 10px"
    },
    "alternate": true
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1746631764520
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1746629661617,
  "afterIndex": 9,
  "blockId": 1746629661617,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "url('')",
        "border-radius": "1rem",
        "padding": "30px 30px 30px 30px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#3B3B3B",
        "box-shadow": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        "width": "none",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsTab": {
        "border-radius": "1rem",
        "width": "auto",
        "padding": "20px 20px 30px 20px"
      },
      "stylePropsMob": {
        "border-radius": "0.75rem",
        "width": "auto",
        "padding": "20px 20px 20px 20px"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "",
        "margin": "0px 0px 0px 0px",
        "border-radius": "9999px",
        "padding": "26px 26px 26px 26px",
        "box-shadow": "",
        "alignItems": "",
        "justify-content": "",
        "flex-direction": "column",
        "display": "",
        "width": "100%",
        "text-align": "left",
        "background-image": "url('')",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover"
      },
      "innerDiv": {
        "styleProps": {
          "height": "auto",
          "width": "auto",
          "border-radius": "50%",
          "display": "flex",
          "flex-direction": "column",
          "alignItems": "flex-start",
          "justify-content": "flex-start"
        },
        "stylePropsTab": {
          "height": "auto"
        },
        "stylePropsMob": {
          "height": "auto"
        }
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px",
        "width": "100%"
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "20px 30px 30px 30px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "left",
        "width": "100%",
        "alignItems": "",
        "text-align": "left",
        "border-width": "0px"
      },
      "stylePropsTab": {
        "padding": "10px 20px 20px 20px"
      },
      "stylePropsMob": {
        "padding": "10px 14px 14px 14px",
        "width": "100%"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "flex",
          "flex-direction": "column",
          "alignItems": "flex-start",
          "justify-content": "flex-start",
          "height": "160px"
        },
        "stylePropsMob": {
          "width": "auto",
          "height": "160px"
        },
        "stylePropsTab": {
          "height": "160px"
        }
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "35%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "center",
          "justify-content": "center"
        }
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": ""
    }
  },
  "containerStyleProps": {
    "max-width": "1280px"
  }
}